import { Component, OnInit } from '@angular/core';
import {
  ControlContainer,
  FormBuilder,
  FormGroup,
  FormGroupDirective,
} from '@angular/forms';
import { filter, Observable } from 'rxjs';
import { EmployeeModel } from '../../../../../../shared/store/employee/types';
import { EmployeeService } from '../../../../../../shared/store/employee/employee.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-employee-form-notes',
    templateUrl: './employee-form-notes.component.html',
    styleUrls: ['./employee-form-notes.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective,
        },
    ],
    standalone: false
})
export class EmployeeFormNotesComponent implements OnInit {
  form: FormGroup;
  employeeDetail$: Observable<EmployeeModel>;
  employeeModel$: Observable<EmployeeModel>;

  constructor(
    private readonly employeeService: EmployeeService,
    private parent: FormGroupDirective,
    private formBuilder: FormBuilder,
  ) {
    this.employeeDetail$ = this.employeeService.getById.value$;
    this.employeeModel$ = this.employeeService.getEmployeeModel.value$;
  }

  ngOnInit(): void {
    this.form = this.parent.form;
    this.form.addControl(
      'notesFormGroup',
      this.formBuilder.group({
        notes: [''],
      }),
    );
    this.employeeDetail$
      .pipe(
        filter((x) => !!x),
        take(1),
      )
      .subscribe((x) => {
        this.form.patchValue({
          notesFormGroup: {
            notes: x.notes,
          },
        });
      });

    this.employeeModel$
      .pipe(
        filter((x) => !!x),
        take(1),
      )
      .subscribe((x) => {
        this.form.patchValue({
          notesFormGroup: {
            notes: x.notes,
          },
        });
      });
  }
}
